import React from 'react';

const CheckboxCell = ({ id, checked, onChange, label, description }) => (
    <div className="grid grid-cols-2 gap-4 items-center py-2 px-3 hover:bg-gray-50 dark:hover:bg-gray-700/50 rounded-md">
        <div>
            <label htmlFor={id} className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
            {description && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{description}</p>}
        </div>
        <div className="flex justify-end">
            <input 
                type="checkbox" 
                id={id} 
                checked={checked}
                onChange={e => onChange(id, e.target.checked)} 
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />
        </div>
    </div>
);

export default CheckboxCell; 